module.exports = __webpack_public_path__ + "media/8.abc1ca06.mp3";